<div class="wishlist" (click)="!loading() && addOrRemoveEntry()">
  <div class="wishlist-icon-block">
    <sd-icon
      class="icon-size-xs icon-size-md-s icon-size-lg-m"
      [class.active]="hasEntry()"
      [type]="hasEntry() ? 'fat-heart-filled' : 'fat-heart'"
    ></sd-icon>
  </div>
</div>
